import axios from 'axios';
import { baseURL, getLoginUrl } from '../utils/Constant';

const axiosInstance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const userData = JSON.parse(localStorage.getItem('userData') || 'null');
    const legacyToken = userData?.token;
    const accessToken = localStorage.getItem('accessToken');
    const token = accessToken || legacyToken;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
let isRefreshing = false;
let pendingQueue = [];

const flushQueue = (error, newToken = null) => {
  pendingQueue.forEach(({ resolve, reject }) => (error ? reject(error) : resolve(newToken)));
  pendingQueue = [];
};

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;
    const originalRequest = error?.config || {};

    if (status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem('refreshToken');
      if (!refreshToken) {
        window.location.href = getLoginUrl();
        return Promise.reject(error);
      }

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          pendingQueue.push({ resolve, reject });
        }).then((newToken) => {
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return axiosInstance(originalRequest);
        });
      }

      isRefreshing = true;
      try {
        const raw = axios.create();
        const tokenResponse = await raw.post(`${baseURL}/auth/token`, {
          grant_type: 'refresh_token',
          refresh_token: refreshToken,
        });

        const { access_token, refresh_token } = tokenResponse.data || {};
        if (!access_token) throw new Error('No access_token from refresh');

        localStorage.setItem('accessToken', access_token);
        if (refresh_token) localStorage.setItem('refreshToken', refresh_token);

        localStorage.setItem('token', access_token);
        const userData = JSON.parse(localStorage.getItem('userData') || 'null');
        if (userData) {
          userData.token = access_token;
          localStorage.setItem('userData', JSON.stringify(userData));
        }

        flushQueue(null, access_token);
        originalRequest.headers.Authorization = `Bearer ${access_token}`;
        return axiosInstance(originalRequest);
      } catch (e) {
        flushQueue(e, null);
        localStorage.clear();
        if(window.location.pathname !== '/login'){
          window.location.href = getLoginUrl();
        }
        return Promise.reject(e);
      } finally {
        isRefreshing = false;
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
